<small class="text-error carbon-error" [class.hide]="_hide">{{ _text }}</small>
